<template>
  <div>
    <section>
      <div class="title-block">区間</div>
      <div class="column section">
        <div v-if="isEnableSwitchStations" class="row">
          <button
            type="button"
            class="button-swap"
            @click="props.switchStations()"
          ></button>
        </div>
        <div class="row">
          <div class="column1">
            <div class="field">
              <label>出発駅</label>
              <div class="select-wrap">
                <select v-model="fromStation" class="form-control">
                  <!-- stationsをループ表示 -->
                  <option
                    v-for="(station, index) in props.fromStationOptions"
                    :key="index"
                    :value="station"
                  >
                    {{ station.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="column2">
            <div class="field">
              <label>到着駅</label>
              <div class="select-wrap">
                <select v-model="toStation" class="form-control">
                  <!-- stationsをループ表示 -->
                  <option
                    v-for="(station, index) in props.toStationOptions"
                    :key="index"
                    :value="station"
                  >
                    {{ station.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="props.isInvalidStations && fromStation.id && toStation.id"
        class="error-block"
      >
        発着駅の指定に誤りがあります。
      </div>
    </section>
  </div>
</template>

<script>
import { computed } from "vue";
import { useVModel } from "vue-composable";

export default {
  name: "MFITTBookingSelectStationSection",
  props: {
    fromStationOptions: {
      type: Array,
      required: true,
    },
    toStationOptions: {
      type: Array,
      required: true,
    },
    fromStation: {
      type: Object,
      required: true,
    },
    toStation: {
      type: Object,
      required: true,
    },
    switchStations: {
      type: Function,
      required: true,
    },
    isInvalidStations: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const fromStation = useVModel(props, "fromStation");
    const toStation = useVModel(props, "toStation");

    // 選択中の着駅が、発駅の選択肢にない場合は入れ替え不可
    // 本来は逆も確認すべきだが、現状の組み合わせ上不要なので省略
    const isEnableSwitchStations = computed(() =>
      props.fromStationOptions.some(
        (station) => station.id == toStation.value.id
      )
    );

    return {
      fromStation,
      toStation,
      isEnableSwitchStations,
      props,
    };
  },
};
</script>
<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.column1 {
  margin-bottom: 15px;
  margin-top: 0;
}

.column2 {
  margin-bottom: 5px;
  margin-top: 0;
}

.column .error-block {
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}

.section {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}

.section .row:first-child {
  width: 40px;
  margin-right: 10px;
}

.section .row:last-of-type {
  width: 100%;
}

.field {
  position: relative;
  margin: 0 0 0 0;
}

.field label {
  position: absolute;
  width: 150px;
  z-index: 100;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  font-size: 13px;
  color: #888888;
}

.button-swap {
  display: block;
  padding: 1em 2em 1em 1em;
  width: 40px;
  height: 100px;
  text-align: center;
  background: #f0f0f0;
  background-image: url("~@/assets/img/icon/svg/icon-swap.svg");
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #cccccc;
  border-radius: 6px;
}

/* セレクトボックス */
select {
  -webkit-appearance: none;
  width: 100%;
  height: 42px;
  margin-bottom: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #ffffff;
  outline: none;
  padding: 12px 10px 12px 150px;
  font-size: 14px;
  line-height: 14px;
  font-weight: bold;
  color: #000000;
}

.ticket-romancecar .form select:focus {
  border-color: #e0e0e0;
}

.select-wrap {
  width: 100%;
  position: relative;
  display: inline-block;
  border-radius: 6px;
}

.select-wrap::after {
  content: "";
  width: 6px;
  height: 6px;
  border: 0px;
  border-bottom: solid 2px #b4b3b3;
  border-right: solid 2px #b4b3b3;
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  top: 20px;
  right: 3vw;
  margin-top: -4px;
}
</style>
